
import {Tooltip, tooltipClasses, TooltipProps} from "@mui/material";
import React from "react";
import {styled} from "@mui/material/styles";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 500,
    },
});

export default (CustomWidthTooltip)